import NewsroomListing from "./NewsroomListing.jsx";
import { PRESS_COVERAGE } from "../data/News.js";

/**
 * ASSOCHAM — Newsroom / Press Coverage
 * How national and global media report on ASSOCHAM's advocacy.
 */
export default function PressCoverage() {
  return (
    <NewsroomListing
      // eyebrow="In the News"
      titleA="Press"
      titleB="Coverage"
      // description="A curated watch of how India's leading dailies, business channels and wire services report on ASSOCHAM's policy advocacy, surveys and interventions across sectors."
      items={PRESS_COVERAGE}
      // listTitle="Press Coverage"
      showSource={true}
    />
  );
}
